export default "__VITE_ASSET__BIM1oBss__"